import { defineMessages } from 'react-intl'

const scope = `procurify.platform.legal-entities.features.view-legal-entity-details.presenters.legal-entity-details-presenter`

export default defineMessages({
  loadErrorTitle: {
    id: `${scope}.loadErrorTitle`,
    defaultMessage: 'We couldn’t load this entity',
  },
  loadErrorMessage: {
    id: `${scope}.loadErrorMessage`,
    defaultMessage:
      'Refresh the page to try again. If the problem continues, contact support.',
  },
  notFoundTitle: {
    id: `${scope}.notFoundTitle`,
    defaultMessage: 'Entity not found',
  },
  notFoundMessage: {
    id: `${scope}.notFoundMessage`,
    defaultMessage: 'This entity may have been removed or never existed.',
  },
})
